


























<template>
  <div class="alpha-gallery">
    <v-container>
      <v-layout row justify-space-around wrap>
        <v-flex xs12 md6 lg4 v-for="project in computedProjects" :key="project.img">
          <slot v-if="$scopedSlots.default" :project="project" />
          <v-card flat height="500px" class="center white--text grey darken-3" @click="dialog = true" v-else>
            <img class="center" :src="`/static/prices/${project.img}`" height="100%" alt="Pricing">
          </v-card>
          <br>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialog" max-width="290">
        <v-card>
          <v-card-title class="headline">Use Google's location service?</v-card-title>

          <v-card-text>
            Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" flat="flat" @click="dialog = false">
              Disagree
            </v-btn>

            <v-btn color="green darken-1" flat="flat" @click="dialog = false">
              Agree
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "alpha-gallery",

  data: () => ({
    category: null,
    dialog: false
  }),

  props: {
    categories: {
      type: Array,
      default: () => []
    },
    projects: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    computedProjects() {
      return !this.category
        ? this.projects
        : this.projects.filter(p => p.categories.includes(this.category));
    }
  },

  methods: {
    genAction(cb) {
      return cb || null;
    },
    select(category) {
      this.category = category.filter;
    }
  }
};
</script>

<style scoped>
.gallery-card {
  transform-origin: center center 0;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
@media only screen and (min-width: 1700px) {
  .center {
    align-content: center;
    padding-left: 10%;
  }
}
</style>
